<template>
  <el-dialog
    v-model="visible"
    :title="
      formType === 1
        ? '重点物料报废'
        : formType === 2
        ? '编辑'
        : '重点物料报废入库'
    "
    width="500px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="formData"
      :rules="rules"
      ref="ruleRef"
      :label-width="formType === 1 ? 100 : 130"
      v-loading="loading"
    >
      <el-form-item label="表具编号：" prop="number">
        <el-input
          :disabled="formType === 3"
          v-model="formData.number"
          v-no-space
          placeholder="请输入"
        />
      </el-form-item>

      <div class="tip" v-if="formType === 2">报废信息</div>

      <el-form-item label="报废日期：" prop="scrapTime" v-if="formType !== 3">
        <el-date-picker
          v-model="formData.scrapTime"
          style="width: 100%"
          type="date"
          placeholder="请选择"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD HH:mm:ss"
          :disabled-date="disabledDate"
        />
      </el-form-item>

      <el-form-item label="报废人：" prop="scrapPerson" v-if="formType !== 3">
        <el-input
          v-model="formData.scrapPerson"
          v-no-space
          placeholder="请输入"
        />
      </el-form-item>

      <div v-if="(formType === 2 && hasInData) || formType === 3">
        <div class="tip" v-if="formType === 2 && hasInData">报废入库信息</div>
        <el-form-item
          label="报废入库日期："
          prop="scrapInTime"
          v-if="formType !== 1"
        >
          <el-date-picker
            v-model="formData.scrapInTime"
            style="width: 100%"
            type="date"
            placeholder="请选择"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
          />
        </el-form-item>

        <el-form-item
          label="报废入库仓库："
          prop="warehouseId"
          v-if="formType !== 1"
        >
          <el-select v-model="formData.warehouseId" style="width: 100%">
            <el-option
              v-for="item in stashList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="入库人："
          prop="scrapInPerson"
          v-if="formType !== 1"
        >
          <el-input
            v-model="formData.scrapInPerson"
            v-no-space
            placeholder="请输入"
          />
        </el-form-item>
      </div>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click="handleSUbmit()"
          :disabled="buttonLoading"
        >
          保存
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import { Add, Update } from "@/api/keyMaterial";
import { ElMessage } from "element-plus";
import useStashList from "../../hooks/useStashList";
const disabledDate = (time) => {
  // 禁用今天之后的日期
  return time.getTime() > Date.now();
};

const emit = defineEmits(["update"]);

const { stashList } = useStashList();

const visible = ref(false); // 弹窗控制

const loading = ref(false); // 遮罩

const buttonLoading = ref(false); // 按钮防抖

const ruleRef = ref(null); // 表单ref
const formType = ref(1); // 1新增 2编辑 3入库
const hasInData = ref(false); // 编辑时是否有报废入库数据

// 表单
const formData = ref({
  id: "",
  number: "",
  scrapTime: "",
  scrapPerson: "",

  scrapInTime: "",
  warehouseId: "",
  scrapInPerson: "",
});

// 表单校验
const rules = reactive({
  number: [{ required: true, message: "请输入", trigger: "blur" }],
  scrapTime: [{ required: true, message: "请选择", trigger: "blur" }],
  scrapInTime: [{ required: true, message: "请选择", trigger: "blur" }],
  warehouseId: [{ required: true, message: "请选择", trigger: "blur" }],
});

// 弹窗打开
const handleDialogOpen = (row, type) => {
  formType.value = type;
  hasInData.value = false;
  console.log("传入数据===>", row);

  switch (formType.value) {
    case 1:
      formData.value = { number: "", scrapTime: "", scrapPerson: "" };
      break;

    case 2:
      formData.value = {
        id: row.id,
        number: row.number,
        scrapTime: row.scrapTime,
        scrapPerson: row.scrapPerson,
      };
      if (row.scrapInTime) {
        hasInData.value = true;
        formData.value.scrapInTime = row.scrapInTime
          ? row.scrapInTime + " 00:00:00"
          : "";
        formData.value.warehouseId = row.warehouseId;
        formData.value.scrapInPerson = row.scrapInPerson;
      }
      break;
    case 3:
      formData.value = {
        id: row.id,
        number: row.number,
        scrapInTime: row.scrapInTime ? row.scrapInTime + " 00:00:00" : "",
        warehouseId: row.warehouseId,
        scrapInPerson: row.scrapInPerson,
      };
      break;
  }

  visible.value = true;
};

// 取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  formData.value = {
    id: "",
    name: "",
    number: "",
    categoryId: "",
    brand: "",
    model: "",
    supplier: "",
    remark: "",
    unit: "",
  };
  visible.value = false;
};
// 保存
const handleSUbmit = () => {
  try {
    buttonLoading.value = true;
    ruleRef.value?.validate((valid) => {
      if (valid) {
        if (formData.value.id) {
          handleEdit();
        } else {
          handleAdd();
        }
      } else {
        buttonLoading.value = false;
      }
    });
  } catch (err) {
    console.log(err);
    buttonLoading.value = false;
  }
};

// 新增
const handleAdd = () => {
  Add({ ...formData.value }).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emit("update");
      handleCancel();
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// 编辑
const handleEdit = () => {
  Update({ ...formData.value }).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emit("update");
      handleCancel();
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// 暴露函数
defineExpose({
  handleDialogOpen,
});
</script>

<style lang="less" scoped>
.tip {
  color: #409eff; /* Element UI 的主题蓝色 */
  padding-left: 10px;
  position: relative;
  margin-bottom: 16px;
  font-size: 16px;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 16px;
    background-color: #409eff;
    border-radius: 2px;
  }
}
</style>
